import { render, staticRenderFns } from "./InstituteGroupSubGroupEnrollment.vue?vue&type=template&id=1dd410c1"
import script from "./InstituteGroupSubGroupEnrollment.vue?vue&type=script&lang=js"
export * from "./InstituteGroupSubGroupEnrollment.vue?vue&type=script&lang=js"
import style0 from "./InstituteGroupSubGroupEnrollment.vue?vue&type=style&index=0&id=1dd410c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports